import React, { useState } from "react";
import { Backdrop, Button, FormFieldSet, LogoLoader, showToast, useFormHandler } from "../../../../components";
import { useSelector } from "react-redux";
import { addLeadContact } from "../../../../redux/slices/bdmjobs/bdmjobsApi";

const AddContactModal = ({ onCancel, companyUiid, onSuccess,isClient}) => {
    const { user } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const validationRules = {
        firstName: {
            type: "text",
            required: true,
        },
        email: {
            type: "text",
            required: true,
        },
        designation: {
            type: "text",
            required: true,
        },
    };

    const initialFormData = {
        firstName: "",
        lastName: "",
        website: "",
        email: "",
        source: "",
        designation: "",
        location:"",
        phone: {
            code: "",
            number: ""
        },
        url: "",
        isPrimary:"1",
        // isClient:"",
    };

    const { formData, errors, handleChange, validateAllFields, setFormData } =
        useFormHandler(initialFormData, validationRules);

    const handleSubmit = async () => {
        const isValid = validateAllFields();
        if (!isValid) return;
        if(!companyUiid) {
            showToast("Company Id is missing.", "error");
            return
        }

        const body = {
            coll: "LeadContact",
            payload: {
                companyId: companyUiid,
                firstName: formData.firstName,
                lastName: formData.lastName,
                email: formData.email,
                designation: formData.designation,
                mobile: {
                    code: formData.phone?.code,
                    number: formData.phone?.number,
                },
                location:formData.location,
                source: formData.source,
                // emailStatus: "Sent",
                url: formData.url,
                websiteUrl: formData.website,
                addedBy: user?.data?.uiid,
                isPrimary:formData.isPrimary === "1"? true : false,
                isClient:isClient
            },
        };
        try {
            setLoading(true);
            const res = await addLeadContact(body);
            if(res?.data) {
                showToast("Contact added successfully", "success");
                onCancel();
                if(onSuccess) onSuccess();
            } else {
                const error = res?.error;
                if (error?.code === 11000) {
                    const name = error?.keyValue?.name;
                    showToast(
                        formData.email.trim()
                            ? `Email "${formData.email}" already exists`
                            : "Email already exists",
                        "error"
                    );
                } else {
                    showToast(
                        res?.data?.msg || "Failed to add contact",
                        "error"
                    );
                }
                // showToast("Failed to add contact","error");
            }
        } catch (error) {
            console.error("Add Lead Contact failed:", error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="flex flex-col gap-5 p-4 sm:p-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
                <FormFieldSet
                    type="text"
                    title="First Name"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.firstName}
                    onChange={(value) => handleChange("firstName", value)}
                    error={errors.firstName}
                    required
                />

                <FormFieldSet
                    type="text"
                    title="Last Name"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.lastName}
                    onChange={(value) => handleChange("lastName", value)}
                    error={errors.lastName}
                />

                <FormFieldSet
                    type="text"
                    title="Designation"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.designation}
                    onChange={(value) => handleChange("designation", value)}
                    error={errors.designation}
                    className="sm:col-span-2 lg:col-span-1"
                    required
                />

                {/* <FormFieldSet
                    type="text"
                    title="URL"
                    shadow={true}
                    placeholder="Enter"
                    value={formData.url}
                    onChange={(value) => handleChange("url", value)}
                    error={errors.url}
                />

                <FormFieldSet
                    type="text"
                    title="Website URL"
                    shadow={true}
                    placeholder="Enter"
                    value={formData.website}
                    onChange={(value) => handleChange("website", value)}
                    error={errors.website}
                /> */}

                <FormFieldSet
                    type="text"
                    title="Email"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.email}
                    onChange={(value) => handleChange("email", value)}
                    error={errors.email}
                    required
                />

                <FormFieldSet
                    type="phone"
                    title="Phone"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.phone?.number || ""}
                    code={formData.phone?.code || ""}
                    onChange={(fullValue, details) =>
                        handleChange(`phone`, {
                            code: details.countryCode,
                            number: details.number,
                        })
                    }
                    error={errors.phone}
                />
                <FormFieldSet
                    title="Location"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.location || ""}
                    code={formData.location || ""}
                    onChange={(value) =>
                        handleChange(`location`, value)
                    }
                    error={errors.location}
                />

                <FormFieldSet
                    type="text"
                    title="Source"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.source}
                    onChange={(value) => handleChange("source", value)}
                    error={errors.source}
                />
                <FormFieldSet
                    type="radio"
                    title="Primary Contact"
                    name={`primaryContact_${companyUiid}`}
                    shadow={true}
                    value={formData.isPrimary}
                    onChange={(e) => handleChange("isPrimary", e.target.value)}
                    error={errors.isPrimary}
                    options={[
                        {label:"Yes" ,value:1},
                        {label:"No" ,value:2},

                    ]}
                />
                

            </div>

            <div className="flex flex-col-reverse sm:flex-row justify-end items-center gap-3 mt-2">
                <Button
                    variant="outlined"
                    title="Cancel"
                    color="black"
                    onClick={() => onCancel()}
                    className="w-full sm:w-auto"
                />
                <Button
                    title="Save"
                    variant="contained"
                    color="primary"
                    className="w-full sm:w-auto"
                    onClick={() => handleSubmit()}
                    disabled={loading}
                />
            </div>
            <Backdrop isOpen={loading}>
                <LogoLoader />
            </Backdrop>
        </div>
    );
};

export default AddContactModal;